const companyInformationQueryKeys = {
  all: [{ scope: 'companyInformation' }] as const,
  detail: (context: { companyId?: string | null }) => [{ ...companyInformationQueryKeys.all[0], ...context }] as const
}

export default companyInformationQueryKeys
